import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useRouteError } from 'react-router-dom';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import { isDevelopment, transform404Error } from '@/utils/application';

import Button from '../components/elements/button';

import classes from '../scss/screens/error.module.scss';

interface ErrorProps {
    customError?: string;
    location?: Location; /** Need to have location as a prop since this element is also used in the router when locationLoader fails */
}

export default function Error({
    customError,
    location,
}: ErrorProps) {
    const error = useRouteError() as Response & Error;
    const navigate = useNavigate();
    const { t } = useTranslation();

    const customErrorMessage = useMemo(() => {
        return `${t('error:move_in_error')} ${location?.contactPhone}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return (
        <div id='error-page' className={classes.error_page}>
            <span className={classes.header}>{t('error:oops')}</span>

            {customError ? (
                <>
                    <p className={classes.p}>{customErrorMessage}</p>
                    {isDevelopment() ? (
                        <span>{transform404Error(customError)}</span>
                    ) : null}
                </>
            ) : (
                <>
                    <p className={classes.p}>{t('error:subtitle')}</p>
                    {(isDevelopment() && error) ? (
                        <i>{transform404Error(error.statusText || error.message)}</i>
                    ) : null}
                    <p className={classes.p1}>{t('error:not_found')}</p>
                </>
            )}

            <Button onclick={() => navigate('/')} type='primary' size='medium'>
                {t('error:go_back')}
            </Button>
        </div>
    );
}
